import type { MatchData } from "./types";

// ==================================================

// MEN'S DOMESTIC MATCHES 2026/27

// UNITED RUGBY CHAMPIONSHIP

// ==================================================

export const matches2026DomesticMen: MatchData[] = [

  // ==================================================

  // URC 2026/27 — ROUND 1

  // ==================================================

  {

    id: 8001,

    matchKey: "benetton-vs-dragons",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-25",

    venue: "Stadio Monigo, Treviso",

    home: { name: "Benetton", country: "urc-benetton" },

    away: { name: "Dragons", country: "urc-dragons" },

    score: { home: 19, away: 19 },
    state: "final",

    startTime: "20:45",

  },

  {

    id: 8002,

    matchKey: "connacht-vs-stormers",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-25",

    venue: "Dexcom Stadium, Galway",

    home: { name: "Connacht", country: "urc-connacht" },

    away: { name: "Stormers", country: "urc-stormers" },

    score: { home: 15, away: 29 },
    state: "final",

    startTime: "20:45",

  },

  {

    id: 8003,

    matchKey: "ulster-vs-edinburgh",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-25",

    venue: "Affidea Stadium, Belfast",

    home: { name: "Ulster", country: "urc-ulster" },

    away: { name: "Edinburgh", country: "urc-edinburgh" },

    score: { home: 29, away: 34 },
    state: "final",

    startTime: "20:45",

  },

  {

    id: 8004,

    matchKey: "lions-vs-leinster",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "10bet Ellis Park, Johannesburg",

    home: { name: "Lions", country: "urc-lions" },

    away: { name: "Leinster", country: "urc-leinster" },
    score: { home: 27, away: 26 },
    state: "final",

    startTime: "13:30",

  },

  {

    id: 8005,

    matchKey: "sharks-vs-ospreys",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "Hollywoodbets Kings Park, Durban",

    home: { name: "Sharks", country: "urc-sharks" },

    away: { name: "Ospreys", country: "urc-ospreys" },
    score: { home: 41, away: 24 },
    state: "final",

    startTime: "16:00",

  },

  {

    id: 8006,

    matchKey: "munster-vs-glasgow-warriors",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "Thomond Park, Limerick",

    home: { name: "Munster", country: "urc-munster" },

    away: { name: "Glasgow Warriors", country: "urc-glasgow-warriors" },
    score: { home: 20, away: 26 },
    state: "final",

    startTime: "18:30",

  },

  {

    id: 8007,

    matchKey: "zebre-parma-vs-bulls",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "Stadio Sergio Lanfranchi, Parma",

    home: { name: "Zebre Parma", country: "urc-zebre-parma" },

    away: { name: "Bulls", country: "urc-bulls" },
    score: { home: 13, away: 47 },
    state: "final",

    startTime: "18:30",

  },

  {

    id: 8008,

    matchKey: "scarlets-vs-cardiff",

    competitionId: "urc",

    tournamentInstanceId: "urc-2027",

    tournament: "United Rugby Championship 2026/27",

    gender: "men",

    round: "Round 1",

    date: "2026-09-26",

    venue: "Parc y Scarlets, Llanelli",

    home: { name: "Scarlets", country: "urc-scarlets" },

    away: { name: "Cardiff", country: "urc-cardiff" },
    score: { home: 15, away: 21 },
    state: "final",

    startTime: "20:45",

  },

// ==================================================
// URC 2026/27 — ROUND 2
// ==================================================
{
  id: 8009,
  matchKey: "cardiff-vs-zebre-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-02",
  venue: "Cardiff Arms Park, Cardiff",
  home: { name: "Cardiff Rugby", country: "wales" },
  away: { name: "Zebre", country: "italy" },
  score: { home: 40, away: 27 },
    state: "final",
  startTime: "20:45",
},

{
  id: 8010,
  matchKey: "benetton-vs-connacht-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-02",
  venue: "Stadio Comunale di Monigo, Treviso",
  home: { name: "Benetton", country: "italy" },
  away: { name: "Connacht", country: "ireland" },
  score: { home: 19, away: 22 },
    state: "final",
  startTime: "20:45",
},

{
  id: 8011,
  matchKey: "dragons-vs-scarlets-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Rodney Parade, Newport",
  home: { name: "Dragons", country: "wales" },
  away: { name: "Scarlets", country: "wales" },
  score: { home: 38, away: 26 },
    state: "final",
  startTime: "16:00",
},

{
  id: 8012,
  matchKey: "glasgow-vs-ulster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Scotstoun Stadium, Glasgow",
  home: { name: "Glasgow Warriors", country: "scotland" },
  away: { name: "Ulster", country: "ireland" },
  score: { home: 33, away: 33 },
    state: "final",
  startTime: "18:30",
},

{
  id: 8013,
  matchKey: "edinburgh-vs-stormers-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-02",
  venue: "Hive Stadium, Edinburgh",
  home: { name: "Edinburgh", country: "scotland" },
  away: { name: "Stormers", country: "south-africa" },
  score: { home: 17, away: 13 },
    state: "final",
  startTime: "20:45",
},

{
  id: 8014,
  matchKey: "lions-vs-ospreys-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Ellis Park, Johannesburg",
  home: { name: "Lions", country: "south-africa" },
  away: { name: "Ospreys", country: "wales" },
  score: { home: 35, away: 19 },
    state: "final",
  startTime: "13:45",
},

{
  id: 8015,
  matchKey: "sharks-vs-leinster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Hollywoodbets Kings Park, Durban",
  home: { name: "Sharks", country: "south-africa" },
  away: { name: "Leinster", country: "ireland" },
  score: { home: 26, away: 20 },
    state: "final",
  startTime: "17:30",
},

{
  id: 8016,
  matchKey: "munster-vs-bulls-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 2",
  date: "2026-10-03",
  venue: "Thomond Park, Limerick",
  home: { name: "Munster", country: "ireland" },
  away: { name: "Bulls", country: "south-africa" },
  score: { home: 26, away: 22 },
    state: "final",
  startTime: "19:45",
},

// ==================================================
// URC 2026/27 — ROUND 3
// ==================================================

{
  id: 8017,
  matchKey: "glasgow-vs-connacht-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-09",
  venue: "Scotstoun Stadium, Glasgow",
  home: { name: "Glasgow Warriors", country: "scotland" },
  away: { name: "Connacht", country: "ireland" },
  score: { home: 39, away: 24 },
  state: "final",
  startTime: "20:45",
},
{
  id: 8018,
  matchKey: "dragons-vs-ospreys-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-09",
  venue: "Rodney Parade, Newport",
  home: { name: "Dragons", country: "wales" },
  away: { name: "Ospreys", country: "wales" },
  score: { home: 22, away: 38 },
  state: "final",
  startTime: "20:45",
},
{
  id: 8019,
  matchKey: "bulls-vs-lions-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Loftus Versfeld, Pretoria",
  home: { name: "Bulls", country: "south-africa" },
  away: { name: "Lions", country: "south-africa" },
  score: { home: 29, away: 24 },
  state: "final",
  startTime: "13:30",
},

{
  id: 8020,
  matchKey: "stormers-vs-sharks-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "DHL Stadium, Cape Town",
  home: { name: "Stormers", country: "south-africa" },
  away: { name: "Sharks", country: "south-africa" },
  score: { home: 39, away: 22 },
  state: "final",
  startTime: "16:00",
},
{
  id: 8021,
  matchKey: "zebre-vs-edinburgh-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Stadio Sergio Lanfranchi, Parma",
  home: { name: "Zebre", country: "italy" },
  away: { name: "Edinburgh", country: "scotland" },
  score: { home: 12, away: 29 },
  state: "final",
  startTime: "16:00",
},
{
  id: 8022,
  matchKey: "scarlets-vs-benetton-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Parc y Scarlets, Llanelli",
  home: { name: "Scarlets", country: "wales" },
  away: { name: "Benetton", country: "italy" },
  score: { home: 27, away: 26 },
  state: "final",
  startTime: "18:30",
},

{
  id: 8023,
  matchKey: "ulster-vs-munster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Affidea Stadium, Belfast",
  home: { name: "Ulster", country: "ireland" },
  away: { name: "Munster", country: "ireland" },
  score: { home: 26, away: 26 },
  state: "final",
  startTime: "18:30",
},
{
  id: 8024,
  matchKey: "leinster-vs-cardiff-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 3",
  date: "2026-10-10",
  venue: "Laya Arena, Dublin",
  home: { name: "Leinster", country: "ireland" },
  away: { name: "Cardiff", country: "wales" },
  score: { home: 29, away: 5 },
  state: "final",
  startTime: "20:45",
},

// ==================================================
// URC 2026/27 — ROUND 4
// ==================================================

{
  id: 8025,
  matchKey: "cardiff-vs-sharks-urc",
   competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-23",
  venue: "Cardiff Arms Park, Cardiff",
  home: { name: "Cardiff", country: "wales" },
  away: { name: "Sharks", country: "south-africa" },
score: { home: 21, away: 36 },
  state: "final",
  startTime: "20:45",
},

{
  id: 8026,
  matchKey: "connacht-vs-zebre-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-23",
  venue: "Dexcom Stadium, Galway",
  home: { name: "Connacht", country: "ireland" },
  away: { name: "Zebre", country: "italy" },
  score: { home: 48, away: 27 },
  state: "final",
  startTime: "20:45",
},

{
  id: 8027,
  matchKey: "edinburgh-vs-lions-urc",
   competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-23",
  venue: "Hive Stadium, Edinburgh",
  home: { name: "Edinburgh", country: "scotland" },
  away: { name: "Lions", country: "south-africa" },
 score: { home: 31, away: 10 },
  state: "final",
  startTime: "20:45",
},

{
  id: 8028,
  matchKey: "bulls-vs-ulster-urc",
   competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "Loftus Versfeld, Pretoria",
  home: { name: "Bulls", country: "south-africa" },
  away: { name: "Ulster", country: "ireland" },
  score: { home: 34, away: 26 },
  state: "final",
  startTime: "13:45",
},

{
  id: 8029,
  matchKey: "stormers-vs-scarlets-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "DHL Stadium, Cape Town",
  home: { name: "Stormers", country: "south-africa" },
  away: { name: "Scarlets", country: "wales" },
  score: { home: 52, away: 40 },
  state: "final",
  startTime: "16:00",
},

{
  id: 8030,
  matchKey: "benetton-vs-glasgow-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "Stadio Comunale di Monigo, Treviso",
  home: { name: "Benetton", country: "italy" },
  away: { name: "Glasgow Warriors", country: "scotland" },
  score: { home: 20, away: 24 },
  state: "final",
  startTime: "16:00",
},

{
  id: 8031,
  matchKey: "leinster-vs-munster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "Aviva Stadium, Dublin",
  home: { name: "Leinster", country: "ireland" },
  away: { name: "Munster", country: "ireland" },
  score: { home: 24, away: 18 },
  state: "final",
  startTime: "19:00",
},

{
  id: 8032,
  matchKey: "ospreys-vs-dragons-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 4",
  date: "2026-10-24",
  venue: "St Helen's, Swansea",
  home: { name: "Ospreys", country: "wales" },
  away: { name: "Dragons", country: "wales" },
  score: { home: 31, away: 14 },
  state: "final",
  startTime: "20:00",
},

//==================================================
// URC 2026/27 – ROUND 5
// ==================================================

{
  id: 8033,
  matchKey: "connacht-vs-leinster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-30",
  venue: "Dexcom Stadium, Galway",
  home: { name: "Connacht", country: "urc-connacht" },
  away: { name: "Leinster", country: "urc-leinster" },
  state: "upcoming",
  startTime: "19:45",
},

{
  id: 8034,
  matchKey: "glasgow-vs-lions-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-30",
  venue: "Scotstoun Stadium, Glasgow",
  home: { name: "Glasgow Warriors", country: "urc-glasgow" },
  away: { name: "Lions", country: "urc-lions" },
  state: "upcoming",
  startTime: "19:45",
},

{
  id: 8035,
  matchKey: "stormers-vs-ulster-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "DHL Stadium, Cape Town",
  home: { name: "Stormers", country: "urc-stormers" },
  away: { name: "Ulster", country: "urc-ulster" },
  state: "upcoming",
  startTime: "14:45",
},

{
  id: 8036,
  matchKey: "bulls-vs-scarlets-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Loftus Versfeld, Pretoria",
  home: { name: "Bulls", country: "urc-bulls" },
  away: { name: "Scarlets", country: "urc-scarlets" },
  state: "upcoming",
  startTime: "17:00",
},

{
  id: 8037,
  matchKey: "benetton-vs-edinburgh-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Stadio Comunale di Monigo, Treviso",
  home: { name: "Benetton", country: "urc-benetton" },
  away: { name: "Edinburgh", country: "urc-edinburgh" },
  state: "upcoming",
  startTime: "15:00",
},

{
  id: 8038,
  matchKey: "munster-vs-sharks-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Thomond Park, Limerick",
  home: { name: "Munster", country: "urc-munster" },
  away: { name: "Sharks", country: "urc-sharks" },
  state: "upcoming",
  startTime: "17:30",
},

{
  id: 8039,
  matchKey: "dragons-vs-zebre-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Rodney Parade, Newport",
  home: { name: "Dragons", country: "urc-dragons" },
  away: { name: "Zebre", country: "urc-zebre" },
  state: "upcoming",
  startTime: "17:30",
},

{
  id: 8040,
  matchKey: "ospreys-vs-cardiff-urc",
  competitionId: "united-rugby-championship",
  tournamentInstanceId: "urc-2027",
  tournament: "United Rugby Championship 2026/27",
  gender: "men",
  round: "Round 5",
  date: "2026-10-31",
  venue: "Swansea.com Stadium, Swansea",
  home: { name: "Ospreys", country: "urc-ospreys" },
  away: { name: "Cardiff", country: "urc-cardiff" },
  state: "upcoming",
  startTime: "19:45",
},

];